import React, { createContext, useState } from "react";

export const UserQueryContext = createContext(); 

export const UserQueryProvider = ({ children }) => {
    const [userQuery, setUserQuery] = useState('');

  return (
    <UserQueryContext.Provider value={{ userQuery, setUserQuery }}>
      {children} 
    </UserQueryContext.Provider>
  );
};
